import { createSlice } from '@reduxjs/toolkit'
import { fetchAllGameTables, fetchGameTableDetails } from 'redux-thunk/thunk/GameTables/gameTables'

const initialState = {
  allGameTables: null,
  gameTableDetails: null
}

const gameTablesSlice = createSlice({
  name: 'gameTablesSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllGameTables.fulfilled, (state, action) => {
        return {
          ...state,
          allGameTables: action.payload
        }
      })
      .addCase(fetchGameTableDetails.fulfilled, (state, action) => {
        return {
          ...state,
          gameTableDetails: action.payload
        }
      })
  }
})

export default gameTablesSlice.reducer
